import { Directive, effect, ElementRef, HostListener, input } from '@angular/core';

@Directive({
  selector: '[appAnimateOpen]',
  standalone: true,
})
export class AnimateOpenDirective {
  appAnimateOpen = input.required<boolean>();
  private isFirstRender = true;
  @HostListener('window:resize')
  onResize(): void {
    this.animationHeightCalc(this.element);
  }

  constructor(private readonly element: ElementRef) {
    element.nativeElement.style.overflow = 'hidden';
    effect(() => {
      this.animationHeightCalc(element);

      if (this.isFirstRender) {
        this.isFirstRender = false;
        setTimeout(() => {
          element.nativeElement.style.transition = 'all 0.175s ease-in-out';
        }, 0);
      }
    });
  }

  animationHeightCalc(element: any) {
    if (this.appAnimateOpen()) {
      let innerContentHeight = 0;

      [...(element.nativeElement?.children || [])].forEach((value: any) => {
        const styles: Record<string, any> = window.getComputedStyle(value);

        let marginAndPaddingHeight = 0;
        ['marginTop', 'marginBottom'].forEach((key) => {
          marginAndPaddingHeight = marginAndPaddingHeight + parseFloat(styles[key] || 0);
        });

        innerContentHeight += value.getBoundingClientRect()?.height + marginAndPaddingHeight;
      });

      element.nativeElement.style.height = `${innerContentHeight}px`;

      setTimeout(() => {
        element.nativeElement.style.height = 'auto';
      });
    } else {
      element.nativeElement.style.height = '0px';
    }
  }
}
